export default __webpack_public_path__ + "static/media/info-24px.00b5df29.svg";